import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

class TableTicket extends PureComponent {
    static propTypes = {
        tickets: PropTypes.object,
        managements: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        tickets: {}
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push(`/${history.environment}/fheticket/${rowData.id}`);
    };

    renderData = memoizeOne((tickets, managements) => {
        const { history } = this.props;
        let result = [];
        Object.keys(tickets).map(ticketId => {
            const ticket = tickets[ticketId];
            result.push({
                id: parseInt(ticketId),
                ref: ticket.ref,
                managementLabel: managements.getIn([ticket.managementId.toString(), 'libelle'], ''),
                assignmentLabel: ticket.assignment.label,
                type: ticket.type ? Translator.translate(`generic.ticketing.type.${ticket.type}`) : null,
                label: ticket.label,
                createdAt: ticket.createdAt,
                creatorLabel: ticket.creator.label,
                state: Translator.translate(`generic.ticketing.state.${ticket.state}`)
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('ticketDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('ticketDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.ref'),
                name: 'ref'
            },
            {
                title: Translator.translate('general.table.column.residence'),
                name: 'managementLabel'
            },
            {
                title: Translator.translate('general.table.column.assignmentLabel'),
                name: 'assignmentLabel'
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'type'
            },
            {
                title: Translator.translate('general.table.column.createdAt'),
                name: 'createdAt'
            },
            {
                title: Translator.translate('general.table.column.creatorLabel'),
                name: 'creatorLabel'
            },
            {
                title: Translator.translate('general.table.column.stateSimple'),
                name: 'state',
                defaultSort: 'asc',
                grouped: 1
            }
        ];
    });

    render() {
        const { profile, tickets, managements, history } = this.props;
        return (
            <FHETable
                idTable="homeDetailTicket"
                columns={this.renderColumns(profile)}
                data={this.renderData(tickets, managements)}
                actions={this.renderActions(profile)}
                emptyDataSourceMessage={Translator.translate(`generic.ticketing.table.body.emptyDataSourceMessage`)}
                minified
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state),
        homeId,
        managements: selectors.getManagements(state)
    };
}

const styles = () => ({
    icon: {
        size: 27
    }
});

export default withRouter(
    renderEnvComponent('scenes/Home/tables/TableHomeTickets', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableTicket)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/tables/TableHomeTickets.js